import PropTypes from 'prop-types'

// Modèle de prévision iaEau d'une station (IAEauModel, DAEau), renvoyé par {stationType}/:id/models et {stationType}/models/all
export const ShapeIAEauModel = PropTypes.shape({
    idStation: PropTypes.number, // Int
    idModel: PropTypes.number, // Int
    typeModel: PropTypes.string, // String
    typeId: PropTypes.number, // Int
    name: PropTypes.string, // Option[String]
    statusCode: PropTypes.number, // Option[Int]
    creationDate: PropTypes.number, // Option[DateTime]
    updateDate: PropTypes.number, // Option[DateTime]
    updateLogin: PropTypes.string, // Option[String]
    params: PropTypes.string, // Option[String] (JSON)
    objective: PropTypes.number, // Option[Int]
    horizon: PropTypes.number, // Option[Int]
    confidenceIndicator: PropTypes.number, // Option[Double]
    calculationDate: PropTypes.number, // Option[DateTime]
    color: PropTypes.string, // Option[String]
    default: PropTypes.bool, // Option[Boolean]
    idScenario: PropTypes.number, // Option[Int]
    yearScenario: PropTypes.number, // Option[Int]
    displayDashboard: PropTypes.bool, // Option[Boolean]
    displaySituation: PropTypes.bool, // Option[Boolean]
    displayAlert: PropTypes.bool, // Option[Boolean]
    jobExecutionId: PropTypes.number, // Option[Long]
    chainCode: PropTypes.string, // Option[String]
    displaySuivi: PropTypes.bool, // Option[Boolean]
    lineType: PropTypes.string, // Option[String]
    lineWidth: PropTypes.number, // Option[Int]
    lineOpacity: PropTypes.number, // Option[Double]
    horizonMode: PropTypes.string, // Option[String]
    calculationMode: PropTypes.string, // Option[String]
    simulationDate: PropTypes.number, // Option[DateTime]
    simulationEndDate: PropTypes.number, // Option[DateTime]
    recurPeriod: PropTypes.string, // Option[String]
    jobId: PropTypes.number, // Option[Int]
    version: PropTypes.string, // Option[String]
    tag: PropTypes.string, // Option[String]
    stationType: PropTypes.string, // String
    stationCode: PropTypes.string, // Option[String]
    stationName: PropTypes.string, // Option[String]
    townCode: PropTypes.string, // Option[String]
})
